import styled from 'styled-components';

export const JaneNameWrapper = styled.span`
  ${({ theme }) => theme.fonts.PoppinsTextBold};
  color: ${({ theme }) => theme.colors.Grey7};
  font-size: 16px;
  line-height: 23px;
  ${({ theme }) => theme.common.Ellipsis};
`;
